export const STRIKE_RANGE = {
    SIX: 6,
    TWELVE: 12,
    TWENTY_FOURE: 24,
    FOURTY_EIGHT: 48,
    ALL: 'ALL'
};
